// Custom plural rules for locales whose grammar vue-i18n's default cannot express.
//
// The default rule picks form 0 when the count is 1 and form 1 otherwise, which is right for
// English, German and Spanish. Russian needs three forms chosen by the last digits, so "1 страна",
// "2 страны" and "5 стран" all differ - and 11 takes the same form as 5, not as 1.

/**
 * Index into a `one | few | many` message for Russian.
 *
 * one  - 1, 21, 31 ... (ends in 1, but not 11)
 * few  - 2-4, 22-24 ... (ends in 2-4, but not 12-14)
 * many - 0, 5-20, 25-30 ... (everything else)
 */
export function russianPluralIndex(choice: number, choicesLength: number): number {
    // Guard for messages that were only given two forms, so they degrade rather than
    // index past the end of the array.
    if (choicesLength < 3) return choice === 1 ? 0 : 1;

    const count = Math.abs(Math.floor(choice));
    const lastDigit = count % 10;
    const lastTwoDigits = count % 100;

    if (lastDigit === 1 && lastTwoDigits !== 11) return 0;
    if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) return 1;
    return 2;
}

export const pluralizationRules = {
    ru: russianPluralIndex
};
